<template>
<div>
  <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-hero section-shaped my-0">
          <div class="shape shape-style-1 bg-gradient-default shape-primary">
              <span class="span-150"></span>
              <span class="span-50"></span>
              <span class="span-50"></span>
              <span class="span-75"></span>
              <span class="span-100"></span>
              <span class="span-75"></span>
              <span class="span-50"></span>
              <span class="span-100"></span>
              <span class="span-50"></span>
              <span class="span-100"></span>
          </div>
          <div class="container shape-container d-flex align-items-center">
              <div class="col px-0">
                  <div class="row justify-content-center align-items-center">
                      <div class="col-lg-12 text-center">
                          <h1 class="text-white">Oops</h1>
                          <p class="lead text-light mt-4 mb-5 col-lg-7 mx-lg-auto">Essa página não existe</p>
                          <div class="btn-wrapper" id="saiba-mais">
                              <base-button tag="a"
                                           href="#saiba-mais"
                                           class="mb-3 mb-sm-0"
                                           type="warning"
                                           size="lg"
                                           style="font-size:20px;width:260px;">
                                  IR PARA A HOME
                              </base-button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <!-- 1st Hero Variation -->
      <section class="section section-shaped my-0 overflow-hidden">
          <div class="shape shape-style-3 bg-gradient-default shape-skew">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
          </div>
          <br /><br />
          <br /><br />
          <br /><br />
      </section>

  </div>
</div>
</template>

<script>
export default {
  name: 'Squeeze',
  components: {

  },
  data(){
    return {
    }
  }
};
</script>

<style scoped lang="scss">
h1 {
  font-size: 3.3rem;
}

@media (min-width: 576px) {
  h1 {
    font-size: 3.3rem;
  }
}

@media (min-width: 768px) {
  h1 {
    font-size: 3.3rem;
  }
}

@media (min-width: 1200px) {
  h1 {
    font-size: 4.5rem;
  }
}

.inverted-image {
  filter: invert(1);
  mix-blend-mode: screen;
}
</style>
